import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { cloneDeep } from 'src/ep-utils';
//import { BaseState } from '../base/base-state'
import { StateHelperService } from '../../../services/proprietary/state-helper.service';
import { ContractObjectDefaults } from './contract-object.defaults';
import { AddNamePointer, RemoveNamePointer } from './contract.actions';
import { AddName, CloneName, DeleteName, RestoreName, UpdateName } from './name.actions';

export interface NameStateModel {
    name: any;
    currentID: string;
}

@State<NameStateModel>({
    name: 'nameState',
    defaults: {
        name: {},
        currentID: null
    }
})
@Injectable()
export class NameState {
    constructor(private helper: StateHelperService) { }

    //******* SELECTORS *********

    @Selector()
    static fullState(state: NameStateModel) {
        return state.name;
    }

    @Selector()
    static currentName(state: NameStateModel) {
        if (state.name[state.currentID]) {
            return state.name[state.currentID];
        } else {
            return {};
        }
    }

    @Selector()
    static names(state: NameStateModel) {
        let result: any = [];
        for (var i in state.name) {
            result.push(state.name[i]);
        }
        return result;
    }

    @Selector()
    static nameCount(state: NameStateModel) {
        let count = 0;
        for (var i in state.name) {
            count++;
        }
        return count;
    }

    //******  ACTIONS  ******

    @Action(UpdateName)
    updateName(sc: StateContext<NameStateModel>, action: UpdateName) {
        const state = sc.getState();
        let nameID = action.Name.Name_ID;
        let updateName: any = { ...action.Name }; //need DEEP copy?  -- subloc list????
        this.helper.setItemChanged(updateName, state.name[nameID].Edit_Status);
        sc.patchState({
            name: {
                ...state.name,
                [nameID]: {
                    ...state.name[nameID],
                    ...updateName
                }
            }
        });
    }

    @Action(DeleteName)
    deleteName(sc: StateContext<NameStateModel>, action: DeleteName) {
        const state = sc.getState();
        let name = { ...state.name }; //shallow copy Name from state
        this.helper.setItemDeleted(name, action.nameID);
        sc.patchState({ name: name });
        if (action.nameID < 0) {
            sc.dispatch(new RemoveNamePointer(action.nameID.toString()));
        }
    }

    @Action(RestoreName)
    restoreName(sc: StateContext<NameStateModel>, action: RestoreName) {
        const state = sc.getState();
        let name = { ...state.name }; //shallow copy Name from state
        this.helper.setItemRestored(name, action.nameID);
        sc.patchState({ name: name });
    }

    @Action(CloneName)
    cloneName(sc: StateContext<NameStateModel>, action: CloneName) {
        const state = sc.getState();
        let srcID = action.nameID;
        let newID = this.helper.getTempID();
        let newName = cloneDeep(state.name[srcID]);
        this.helper.setItemAdded(newName);
        newName.Name_ID = newID;
        sc.patchState({
            currentID: newID,
            name: { ...state.name, [newID]: newName }
        });
        sc.dispatch(new AddNamePointer(newID));
    }

    @Action(AddName)
    addName(sc: StateContext<NameStateModel>, action: AddName) {
        const state = sc.getState();
        let newID = this.helper.getTempID();
        let newName = this.helper.createDefaultItem(ContractObjectDefaults, 'Contract_Name', action.Name);
        this.helper.setItemAdded(newName);
        newName.Name_ID = newID;
        sc.patchState({
            currentID: newID,
            name: { ...state.name, [newID]: newName }
        });
        sc.dispatch(new AddNamePointer(newID));
    }
}
